import React from "react";
import { Link, useNavigate } from "react-router-dom";

const PageTitle = ({ title, breadcrumb, state, back }) => {
  const { from, current } = breadcrumb;
  const navigate = useNavigate();

  return (
    <>
      {/* <!-- start page title --> */}
      <div className='row'>
        <div className='col-12 '>
          <div className='page-title-box'>
            <div className='page-title-right'>
              <ol className='breadcrumb m-0'>
                <li className='breadcrumb-item'>
                  <Link to='/admin/dashboard'>PCM</Link>
                </li>
                {
                  <li className='breadcrumb-item'>
                    {!back ? (
                      <Link to={from.link} state={state}>
                        {from.title}
                      </Link>
                    ) : (
                      <span
                        className='breadcrumb-item text-primary cursor-p'
                        onClick={() => navigate(-1)}
                      >
                        {from.title}
                      </span>
                    )}
                  </li>
                }
                {<li className='breadcrumb-item active'>{current.title}</li>}
              </ol>
            </div>
            <h4 className='page-title'>{title}</h4>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}
    </>
  );
};

export default PageTitle;
